import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LoadingScreen } from '../components/AppRecovery';
import { readPreviewTeam } from '../service/previewStorage';
import SideBar from '../components/SideBar';
import { isAuth, isAuthAsWaited } from '../redux/selector/User';
import Home from '../page/Home';
import Team from '../page/Team';
import Manager from '../page/Manager';
import Transfers from '../page/Transfers';
import Finance from '../page/Finance';
import League from '../page/League';
import DomesticCup from '../page/DomesticCup';
import CrossServer from '../page/CrossServer';
import UserGuide from '../page/UserGuide';
import Stuff from '../page/Stuff';
import HiddenPage from '../page/Hidden';

export default function PrivateAppShell() {
  const location = useLocation();
  const isUserAuth = useSelector(isAuth);
  const isAuthenticated = isUserAuth || Boolean(readPreviewTeam());
  const isAuthenticatedAsWaiter = useSelector(isAuthAsWaited);
  const isPublicUserGuide = location.pathname.startsWith('/user-guide');

  if (isAuthenticatedAsWaiter) {
    return <Redirect to="/signup" />;
  }
  // Public SEO: user guide is crawlable while logged out (no app chrome).
  if (isAuthenticated === false && isPublicUserGuide) {
    return (
      <Switch>
        <Route path="/user-guide" component={UserGuide} />
      </Switch>
    );
  }
  if (isAuthenticated === false) {
    return <Redirect to="/" />;
  }
  if (!isAuthenticated) {
    return <LoadingScreen />;
  }

  return (
    <SideBar>
      <Switch>
        <Route exact path="/home" component={Home} />
        <Route path="/home/player/:playerId" component={Home} />
        <Route path="/league" component={League} />
        <Route path="/finance" component={Finance} />
        <Route path="/team" component={Team} />
        <Route path="/manager" component={Manager} />
        <Route path="/transfers" component={Transfers} />
        <Route path="/domestic-cup" component={DomesticCup} />
        <Route path="/cross-server" component={CrossServer} />
        <Route path="/user-guide" component={UserGuide} />
        <Route path="/stuff" component={Stuff} />
        <Route exact path="/_page_that_consist_discord" component={HiddenPage} />
        <Redirect to="/home" />
      </Switch>
    </SideBar>
  );
}
